export const siteStats = [
  { label: '今日新增档案', value: '36', unit: '条' },
  { label: '累计收录', value: '1,842', unit: '份' },
  { label: '正在热议', value: '207', unit: '话题' },
];

export const heroLead = {
  title: '深夜直播口误连环翻车，三小时掉线三万观众',
  codename: '游戏主播·夜宵',
  status: '持续发酵',
  heat: 98,
  comments: 1247,
  updated: '09-09 23:41',
  summary:
    '从一句口误到接连三轮回应，直播切片被反复搬运。吃瓜重点集中在「时间线」与「前后说法不一致」两处，档案正在持续补充。',
  tags: ['直播翻车', '回应合集', '时间线'],
  image:
    'https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20of%20an%20anonymous%20silhouette%20figure%20behind%20frosted%20glass%2C%20warm%20amber%20and%20terracotta%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20no%20identifiable%20face%2C%20clean%20minimal%20cream%20background%2C%20magazine%20cover%20style%2C%20restrained%20moody%20mood%2C%20high%20detail&width=1200&height=800&seq=hl-hero-lead-01&orientation=landscape',
};

export const heroSmall = [
  {
    title: '联名款被指换标涨价，客服前后回应不一',
    codename: '穿搭博主·猫九',
    heat: 87,
    comments: 862,
    tag: '带货争议',
    image:
      'https://readdy.ai/api/search-image?query=Studio%20microphone%20and%20ring%20light%20on%20a%20clean%20cream%20desk%2C%20warm%20amber%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20soft%20shadows%2C%20no%20faces%2C%20neutral%20warm%20background%2C%20high%20detail&width=640&height=480&seq=hl-hero-s1-01&orientation=landscape',
  },
  {
    title: '探店视频被扒同日双店拍摄，行程对不上',
    codename: '探店博主·阿满',
    heat: 79,
    comments: 604,
    tag: '真实性存疑',
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20glowing%20screen%20on%20a%20warm%20neutral%20table%20surface%2C%20soft%20amber%20light%2C%20minimal%20editorial%20still%20life%2C%20clean%20cream%20background%2C%20no%20faces%2C%20restrained%20composition%2C%20high%20detail&width=640&height=480&seq=hl-hero-s2-01&orientation=landscape',
  },
  {
    title: '旧微博被翻出，早年言论引发大范围讨论',
    codename: '摄影博主·鹿野',
    heat: 92,
    comments: 1533,
    tag: '考古现场',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20blank%20paper%20documents%20and%20a%20pen%20on%20a%20warm%20cream%20desk%2C%20soft%20neutral%20daylight%2C%20minimal%20editorial%20photography%2C%20clean%20restrained%20composition%2C%20no%20text%2C%20high%20detail&width=640&height=480&seq=hl-hero-s3-01&orientation=landscape',
  },
];

export const hotChips = [
  { label: '直播翻车', count: 128 },
  { label: '带货翻车', count: 96 },
  { label: '考古现场', count: 74 },
  { label: '行程对不上', count: 63 },
  { label: '应援账目', count: 58 },
  { label: '解约风波', count: 41 },
];

export const tickerItems = [
  '直播切片被反复搬运，相关话题连续 6 小时挂在热点位',
  '品牌方删除联名宣传帖，评论区已关闭',
  '后援会公开账目初稿，网友逐条核对中',
  '同款商品评价区出现大量「和宣传不一致」反馈',
];

export const quickNews = [
  { time: '23:41', text: '夜宵直播回应第二轮，仍未说明当日行程细节', tag: '持续发酵' },
  { time: '22:08', text: '猫九联名款页面悄然下架，客服话术前后不一致', tag: '待核实' },
  { time: '20:35', text: '阿满同日双店拍摄被行程单佐证，暂未回应', tag: '待核实' },
  { time: '19:12', text: '鹿野旧帖被整理成时间线，转发量破两万', tag: '考古' },
  { time: '17:50', text: '小满星应援账目公开，收支差额部分备注缺失', tag: '持续发酵' },
  { time: '16:26', text: '老何品牌直播临时取消，双方各执一词', tag: '待核实' },
];

export const dataPanel = [
  { label: '争议热度', value: 92, tone: 'primary' },
  { label: '讨论参与度', value: 78, tone: 'accent' },
  { label: '信息完整度', value: 54, tone: 'secondary' },
  { label: '官方回应进度', value: 38, tone: 'primary' },
];

export const archiveCategories = ['全部', '最新更新', '高热度', '持续发酵', '待核实', '已回应'];

export const archiveItems = [
  {
    id: 'a1',
    title: '深夜直播口误连环翻车，三小时掉线三万观众',
    codename: '游戏主播·夜宵',
    category: '持续发酵',
    heat: 98,
    comments: 1247,
    date: '09-09',
    tags: ['直播', '回应'],
    image:
      'https://readdy.ai/api/search-image?query=Ring%20light%20and%20camera%20on%20a%20warm%20neutral%20backdrop%2C%20soft%20amber%20studio%20lighting%2C%20minimal%20editorial%20still%20life%2C%20clean%20cream%20background%2C%20no%20faces%2C%20restrained%20mood%2C%20high%20detail&width=800&height=560&seq=hl-arc-01&orientation=landscape',
  },
  {
    id: 'a2',
    title: '联名款被指换标涨价，客服前后回应不一致',
    codename: '穿搭博主·猫九',
    category: '待核实',
    heat: 87,
    comments: 862,
    date: '09-08',
    tags: ['带货', '联名'],
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20with%20notification%20cards%20on%20a%20warm%20cream%20desk%2C%20soft%20neutral%20lighting%2C%20minimal%20editorial%20photography%2C%20clean%20restrained%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=hl-arc-02&orientation=landscape',
  },
  {
    id: 'a3',
    title: '探店视频被扒同日双店拍摄，行程对不上',
    codename: '探店博主·阿满',
    category: '待核实',
    heat: 79,
    comments: 604,
    date: '09-08',
    tags: ['探店', '质疑'],
    image:
      'https://readdy.ai/api/search-image?query=Condenser%20microphone%20closeup%20on%20a%20warm%20neutral%20surface%2C%20soft%20amber%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20clean%20cream%20background%2C%20no%20faces%2C%20high%20detail&width=800&height=560&seq=hl-arc-03&orientation=landscape',
  },
  {
    id: 'a4',
    title: '旧微博被翻出，早年言论引发大范围讨论',
    codename: '摄影博主·鹿野',
    category: '已回应',
    heat: 92,
    comments: 1533,
    date: '09-07',
    tags: ['考古', '道歉'],
    image:
      'https://readdy.ai/api/search-image?query=Shopping%20bags%20and%20paper%20receipts%20on%20a%20warm%20cream%20surface%2C%20soft%20neutral%20lighting%2C%20minimal%20editorial%20still%20life%2C%20restrained%20composition%2C%20clean%20background%2C%20high%20detail&width=800&height=560&seq=hl-arc-04&orientation=landscape',
  },
  {
    id: 'a5',
    title: '粉丝后援会账目公开，部分收支备注缺失',
    codename: '应援站·小满星',
    category: '持续发酵',
    heat: 85,
    comments: 998,
    date: '09-07',
    tags: ['应援', '账目'],
    image:
      'https://readdy.ai/api/search-image?query=Headphones%20and%20game%20controller%20on%20a%20warm%20neutral%20desk%2C%20soft%20amber%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20clean%20cream%20background%2C%20no%20faces%2C%20high%20detail&width=800&height=560&seq=hl-arc-05&orientation=landscape',
  },
  {
    id: 'a6',
    title: '品牌直播临时取消，双方说法各执一词',
    codename: '数码博主·老何',
    category: '待核实',
    heat: 71,
    comments: 430,
    date: '09-06',
    tags: ['商务', '解约'],
    image:
      'https://readdy.ai/api/search-image?query=Dumbbells%20and%20a%20folded%20towel%20on%20a%20warm%20neutral%20floor%2C%20soft%20amber%20lighting%2C%20minimal%20editorial%20still%20life%2C%20clean%20cream%20background%2C%20restrained%20composition%2C%20high%20detail&width=800&height=560&seq=hl-arc-06&orientation=landscape',
  },
  {
    id: 'a7',
    title: '健身课价格表流出，与页面宣传不一致',
    codename: '健身博主·铁牛',
    category: '已回应',
    heat: 66,
    comments: 388,
    date: '09-05',
    tags: ['课程', '价格'],
    image:
      'https://readdy.ai/api/search-image?query=Makeup%20brushes%20and%20a%20neutral%20palette%20on%20a%20warm%20cream%20surface%2C%20soft%20amber%20lighting%2C%20minimal%20editorial%20photography%2C%20clean%20restrained%20composition%2C%20no%20faces%2C%20high%20detail&width=800&height=560&seq=hl-arc-07&orientation=landscape',
  },
  {
    id: 'a8',
    title: '旅游攻略被指洗稿，原作者晒出对比图',
    codename: '旅行博主·风间',
    category: '最新更新',
    heat: 74,
    comments: 512,
    date: '09-05',
    tags: ['洗稿', '对比'],
    image:
      'https://readdy.ai/api/search-image?query=Suitcase%20and%20passport%20resting%20on%20a%20warm%20neutral%20bench%2C%20soft%20daylight%2C%20minimal%20editorial%20still%20life%2C%20clean%20cream%20background%2C%20restrained%20composition%2C%20high%20detail&width=800&height=560&seq=hl-arc-08&orientation=landscape',
  },
];

export const nameList = [
  { rank: 1, codename: '游戏主播·夜宵', field: '直播', heat: 98, comments: 1247, trend: 'up' },
  { rank: 2, codename: '摄影博主·鹿野', field: '影像', heat: 92, comments: 1533, trend: 'up' },
  { rank: 3, codename: '穿搭博主·猫九', field: '时尚', heat: 87, comments: 862, trend: 'flat' },
  { rank: 4, codename: '应援站·小满星', field: '应援', heat: 85, comments: 998, trend: 'up' },
  { rank: 5, codename: '探店博主·阿满', field: '美食', heat: 79, comments: 604, trend: 'down' },
  { rank: 6, codename: '旅行博主·风间', field: '旅行', heat: 74, comments: 512, trend: 'flat' },
  { rank: 7, codename: '数码博主·老何', field: '科技', heat: 71, comments: 430, trend: 'down' },
  { rank: 8, codename: '健身博主·铁牛', field: '运动', heat: 66, comments: 388, trend: 'flat' },
  { rank: 9, codename: '美妆博主·棠棠', field: '美妆', heat: 61, comments: 350, trend: 'up' },
  { rank: 10, codename: '音乐人·南屿', field: '音乐', heat: 57, comments: 296, trend: 'flat' },
];

export const discussions = [
  {
    id: 'd1',
    user: '瓜田里的猹',
    time: '12 分钟前',
    topic: '游戏主播·夜宵',
    text: '把三轮回应的时间点排一排就看得出来，第二轮的行程说明和直播里说的是对不上的。',
    likes: 428,
    replies: 63,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20terracotta%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-01&orientation=squarish',
  },
  {
    id: 'd2',
    user: '只吃熟的瓜',
    time: '38 分钟前',
    topic: '穿搭博主·猫九',
    text: '客服话术两套截图我都留着，等官方给个统一说法再下结论，先标记待核实。',
    likes: 316,
    replies: 41,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-02&orientation=squarish',
  },
  {
    id: 'd3',
    user: '档案管理员',
    time: '1 小时前',
    topic: '应援站·小满星',
    text: '账目里三笔支出的备注是空的，占比不大但确实缺说明，已经补进档案了。',
    likes: 274,
    replies: 55,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20sage%20green%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-03&orientation=squarish',
  },
  {
    id: 'd4',
    user: '路过的吃瓜群众',
    time: '2 小时前',
    topic: '摄影博主·鹿野',
    text: '考古帖我翻完了，早年那段确实存在，回应也算及时，剩下的看后续。',
    likes: 198,
    replies: 29,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20muted%20rose%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-04&orientation=squarish',
  },
  {
    id: 'd5',
    user: '对比图收藏家',
    time: '3 小时前',
    topic: '旅行博主·风间',
    text: '把两篇攻略的段落顺序叠一起，重合的部分太整齐了，不像巧合。',
    likes: 156,
    replies: 22,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20sand%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-05&orientation=squarish',
  },
  {
    id: 'd6',
    user: '深夜蹲更新',
    time: '4 小时前',
    topic: '探店博主·阿满',
    text: '行程单出来之后就没再更新回应了，蹲一个正式说明。',
    likes: 121,
    replies: 18,
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20deep%20olive%20circular%20avatar%20with%20anonymous%20silhouette%2C%20no%20face%20details%2C%20flat%20minimal%20illustration%2C%20clean%20cream%20background%2C%20soft%20texture&width=200&height=200&seq=hl-av-06&orientation=squarish',
  },
];

export const timeline = [
  { date: '09-09', phase: '发酵', title: '直播切片被大量搬运', desc: '相关话题连续 6 小时停留在热点位，讨论量短时间翻倍。' },
  { date: '09-09', phase: '回应', title: '第二轮回应发布', desc: '回应中未说明当日行程细节，网友提出新的疑点。' },
  { date: '09-08', phase: '核实', title: '档案组补充时间线', desc: '把直播、动态、第三方记录对齐，标出三处对不上的节点。' },
  { date: '09-08', phase: '围观', title: '评论区转向复盘', desc: '讨论从情绪输出转到逐条核对，出现不少整理型长评。' },
  { date: '09-07', phase: '待核实', title: '多家账号要求说明', desc: '相关方暂无统一说法，档案状态标记为「待核实」。' },
  { date: '09-06', phase: '归档', title: '旧内容被重新翻出', desc: '更早的动态被整理成合集，进入考古视角。' },
];

export const collections = [
  { id: 'c1', title: '直播翻车合集', desc: '口误、切错画面、连麦翻车的统一归档，按场次编号。', count: 128, icon: 'ri-live-line', tone: 'primary' },
  { id: 'c2', title: '带货争议专题', desc: '价格、联名、宣传与实物不一致的对比整理。', count: 96, icon: 'ri-shopping-bag-3-line', tone: 'accent' },
  { id: 'c3', title: '考古现场合集', desc: '旧帖、旧动态、旧采访的查找与时间线还原。', count: 74, icon: 'ri-archive-line', tone: 'secondary' },
  { id: 'c4', title: '响应与声明汇总', desc: '各方声明原文对比，标注发布顺序与关键差异。', count: 63, icon: 'ri-file-text-line', tone: 'primary' },
  { id: 'c5', title: '应援账目核对', desc: '公开账目的收支核对与缺失备注标记。', count: 41, icon: 'ri-file-list-3-line', tone: 'accent' },
  { id: 'c6', title: '解约与商务风波', desc: '合作变动、直播取消、预告跳票的集中记录。', count: 35, icon: 'ri-exchange-line', tone: 'secondary' },
];